/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../../Components/Utility/Loader/Loader';
import {getRanglePlanLogs, clearRangeLogs, deleteRanglePlanLogs } from './store/ProductList.action';
import './RangePlan.css';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { getPreReadSignedWriteUrl } from '../../../services/s3Services';

function RangePlanLogs() {
  const dispatch = useDispatch();
  const [rangePlanData, setRangePlanData] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const listInnerRef = useRef();

  const { t } = useTranslation('common');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({
    pageNumber: 1,
    pageSize: 20,
    totalCount: 0,
    scrollLoader: false,
    hasMore: false,
    dataList: [],
    isDataLoaded: false,
  });
  const { pageNumber, pageSize } = state;
  const { CheckActionPermission } = useComponent();

  const reducers = useSelector((redState) => redState);
  const {
    ProductListData: { rangePlanLogs, totalCount },
    Users: { logInRights },
  } = reducers;
  const rangePlanDeleteAccess = CheckActionPermission(logInRights, 'rangePlan', 'default', 'delete');

  const getRangePlan = async (pageNo) => {
    setLoading(true);
    const reqObj = {
      pageNumber: pageNo || pageNumber,
      pageSize,
    };
    await dispatch(getRanglePlanLogs(reqObj));
    setLoading(false);
  };
  useEffect(() => {
    getRangePlan();
    return () => {
      dispatch(clearRangeLogs());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNextPageInScroll = async () => {
    const nextPageIndex = pageNumber + 1;
    setState((prevState) => ({
      ...prevState,
      pageNumber: nextPageIndex,
    }));

    const params = {
      pageNumber: nextPageIndex,
      pageSize,
    };

    dispatch(getRanglePlanLogs(params));
  };

  useEffect(() => {
    if (rangePlanLogs?.length > 0) {
      setRangePlanData(rangePlanLogs);
      setState((prevState) => ({
        ...prevState,
        totalCount,
        hasMore: totalCount > rangePlanLogs?.length,
      }));
    }
  }, [rangePlanLogs, totalCount]);

  const downloadFile = async (item) => {
    const fileUrl = item.fileUrl?.toString?.() || '';
    if (!fileUrl) return;
    const isFullUrl = fileUrl.startsWith('http');
    let href = fileUrl;
    if (!isFullUrl) {
      const res = await getPreReadSignedWriteUrl({ objectKey: fileUrl });
      if (res?.code !== 200 || !res?.data) return;
      href = res.data;
    }
    const fileName = fileUrl.split('/').pop() || 'download';
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const handleBack = () => {
    const previousRoute = location?.state?.from;
    if (previousRoute) {
      history.push(previousRoute);
    } else if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/rangeplan/card-view');
    }
  };

  const showModules = (module) => {
    // Mapping for static module names to their proper names
    const moduleNames = {
      productInfo: 'Product Information',
      supplierInfo: 'Supplier Information',
      bomInfo: 'BOM Information',
      measurementInfo: 'Specifications Information',
      testingInfo: 'Testing Information',
      careUserInfo: 'Care/User Information',
      careUserInfoDocument: 'Care Documents',
      sampleInfo: 'Sample Information',
      costingInfo: 'Costing Information',
      POInfo: 'Purchase Order',
      coreProductInfo: 'Core Product Information',
      productTesting: 'Testing Information',
      specification: 'Specifications Information',
      productBOM: 'BOM Information',
      productSupplier: 'Supplier Information',
      productIdentifier: 'Product Identifier',
      careLabelInfo: 'Care/User Information',
      careLabelDocument: 'Care Documents',
    };

    // Check if the module is in the static list
    if (moduleNames[module.downloadSelectedInfo]) {
      return moduleNames[module.downloadSelectedInfo];
    }

    // Handle custom sections
    return module?.customSection?.map((ele) => ele?.name).join(', ');
  };

  const deleteFiles = async (item) => {
    if (item?._id) {
      setLoading(true);
      const reqObj = {
        id: item?._id,
      };
      dispatch(clearRangeLogs());
      setRangePlanData([]);
      const res = await dispatch(deleteRanglePlanLogs(reqObj, t));
      if (res) {
        await getRangePlan(1);
      }
      setLoading(false);
    }
  };

  const itemStatus = (status) => {
    if (status === 'Finish') {
      return 'f-14  range-badge  badge badge-success';
    }
    if (status === 'Failed') {
      return 'f-14 range-badge  badge badge-danger';
    }
    return 'f-14 range-badge  badge badge-warning';
  };
  return (
    <div>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <span className="title">{t('RANGE_PLANS.PRODUCT_LIST.DOWNLOAD_LOG')}</span>
        </div>

        <button type="button" aria-label="button" className="cursor-pointer p-0 d-inline-flex btn ml-auto" onClick={handleBack}>
          <i className="icon-close f-20" />
        </button>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div
          id="scrollableDiv_PIM"
          style={{
            height: 'calc(100vh - 135px)',
            overflowY: 'auto',
          }}
          ref={listInnerRef}
        >
          <InfiniteScroll
            dataLength={rangePlanData?.length}
            hasMore={state?.hasMore}
            next={handleNextPageInScroll}
            scrollableTarget="scrollableDiv_PIM"
            className="fixed-col-container"
          >
            <Container className="range-plan-logs" fluid>
              <Row>
                {rangePlanData?.length > 0 &&
                  rangePlanData?.map((item) => (
                    <div
                      id="accordion"
                      key={item?._id}
                      className="col-lg-4 "
                      onClick={() => {
                        setShow(!show);
                      }}
                      role="button"
                      tabIndex={0}
                    >
                      <div className="common-listing-card card mt-24">
                        <div className="card-header d-flex align-items-center">
                          <ul className="card-header-icon ml-auto">
                            <li>
                              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DOWNLOAD_FILE')}>
                                <button
                                  className="btn p-0"
                                  type="button"
                                  aria-label="download"
                                  disabled={item?.status !== 'Finish'}
                                  onClick={() => downloadFile(item)}
                                >
                                  <i className="icon-download" />
                                </button>
                              </CustomTooltip>
                            </li>

                            {rangePlanDeleteAccess && (
                              <li>
                                <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DELETE')}>
                                  <button className="btn p-0" type="button" aria-label="delete" onClick={() => deleteFiles(item)}>
                                    <i className="icon-delete" />
                                  </button>
                                </CustomTooltip>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="card-body">
                          <ul className="card-ul ">
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.DOWNLOAD_BY')}: </strong>
                              {item?.userId?.firstName} {item?.userId?.lastName}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.LOG_DATE')}: </strong>
                              {item?.createdAt ? moment(item?.createdAt).format('DD-MMM-YYYY, HH:mm') : ''}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.RANGE_PLAN_NAME')}: </strong>
                              {item?.rangeplanId?.name || '--'}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.FILE')}: </strong>
                              {item?.fileUrl?.split('/').pop() || item?.fileUrl}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.MODULES')}: </strong>
                              {showModules(item)}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.SEASONS')}: </strong>
                              {item?.filterObj?.seasonDetails?.map((season) => season?.name).join(', ')}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.YEARS')}: </strong>
                              {item?.filterObj?.year?.join(', ')}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.MONTHS')}: </strong>
                              {item?.filterObj?.month?.join(', ')}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_TYPES')}: </strong>
                              {item?.filterObj?.productTypeDetails?.map((type) => type?.name).join(', ')}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.STATUS')}: </strong>
                              <span className={itemStatus(item?.status)}>{item?.status === 'Finish' ? 'Completed' : item?.status}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                {!loading && rangePlanData?.length === 0 && (
                  <Col lg={12} className="d-flex mt-16 justify-content-center">
                    {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORD_FOUND')}
                  </Col>
                )}
              </Row>
            </Container>
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}

export default RangePlanLogs;
